import { FC } from 'react';
import { SupportedMediums } from 'modules/frequencyManagement/lib/types';
import { useCoreContext } from 'modules/frequencyManagement/contexts/CoreContext';
import { SummaryBanner } from 'modules/frequencyManagement/lib/components/summaryBanner/SummaryBanner';

export interface ManagementSettingsSummaryBannerProps {
  messageMedium: SupportedMediums;
}
export const ManagementSettingsSummaryBanner: FC<ManagementSettingsSummaryBannerProps> = ({
  messageMedium,
}) => {
  const { frequencyManagementData } = useCoreContext();
  return <SummaryBanner config={frequencyManagementData} messageMedium={messageMedium} />;
};
